import { React, useEffect } from "react";
import Button from 'react-bootstrap/Button';
import Navbar from 'react-bootstrap/Navbar';
import Badge from 'react-bootstrap/Badge';
import Nav from 'react-bootstrap/Nav';
import menuLogo from "../assets/imagens/pentalobe.png";
import { useDispatch, useSelector } from "react-redux";
import { checkAuth } from '../redux/reducers/userSlice'; // Importa o thunk
import { useLocation } from 'react-router-dom';

const MenuPrincipal = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.user)
    const location = useLocation();
    const navbarClass = location.pathname === "/" ? "fundo-nav" : "fundo-nav-2";
    const isHomeRoute = location.pathname === "/";
    const isActive = (path) => location.pathname === path ? 'active' : ''
    const { products } = useSelector((state) => state.cart);
    //console.log("Produtos no MenuPrincipal:", products);

    useEffect(() => {
        if (!user) {
            dispatch(checkAuth());
        }
    }, [user, dispatch]);
    return (
        <div>
            <Navbar expand="lg" className={`${navbarClass} d-flex justify-content-center align-items-center flex-direction-row`} >
                <div className="header-container">
                    <a href="/"><img className="logo-menu" src={menuLogo} alt="fundo-imagem-home" /></a>
                </div>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav ">
                    <Nav className="nav-item config-celular">
                        <Nav.Link href="/"><Button className={`botao-geral-menu config-celular-botao ${isActive('/')}`}>Home</Button></Nav.Link>
                        <Nav.Link href="/quero-vender"><Button className={`botao-geral-menu config-celular-botao ${isActive('/quero-vender')}`}>Quero Vender</Button></Nav.Link>
                        <Nav.Link href="/quero-comprar"><Button className={`botao-geral-menu config-celular-botao ${isActive('/quero-comprar')}`}>Quero Comprar</Button></Nav.Link>
                        {/*<Nav.Link href="/quero-comprar"><Button className="botao-geral-menu config-celular-botao">Quero Comprar</Button></Nav.Link>*/}
                        <Nav.Link href="/blog"><Button className={`botao-geral-menu config-celular-botao ${isActive('/blog')}`}>Blog</Button></Nav.Link>
                        <Nav.Link href="/login"><Button className="botao-geral-menu config-celular-botao">Login</Button></Nav.Link>
                        {!isHomeRoute && (
                            <Nav.Link href="/carrinho" >
                                <Button className="botao-geral-menu config-celular-botao" style={{ border: 'none' }}>
                                    <i className="fa-solid fa-shopping-cart cart-icon"></i>
                                    {products.length > 0 && (
                                        <Badge pill className="cart-count">
                                            {products.length}
                                        </Badge>
                                    )}
                                </Button>
                            </Nav.Link>
                        )}
                        {!isHomeRoute && user !== undefined && (
                            <Nav.Link href="/dashboard" >
                                <div className="user-greeting-container d-none d-md-block">
                                    <button className="user-greeting" >
                                        <a  target="_blanck" style={{ textDecoration: 'none', color: '#FFFF' }} > {user ? `Olá, ${user?.name?.split(" ")[0]}!` : "Olá, visitante!"}</a>
                                    </button>
                                </div>
                            </Nav.Link>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>

        </div>
    );
};

export default MenuPrincipal;